<template>
  <el-dialog v-model="dialogVisible" title="订单调价" width="420px">
    <el-form ref="formRef" v-loading="formLoading" :model="formData" label-width="100px">
      <el-form-item label="应付金额(总)">
        <el-input v-model="formData.payPrice" disabled />
      </el-form-item>
      <el-form-item label="订单调价">
        <el-input-number v-model="formData.adjustPrice" :precision="2" :step="0.1" class="!w-full" />
        <el-tag class="mt-8px" type="warning">正数加价，负数减价</el-tag>
      </el-form-item>
      <el-form-item label="调价后">
        <el-input v-model="formData.newPayPrice" disabled />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :disabled="formLoading" type="primary" @click="submitForm">确定</el-button>
    </template>
  </el-dialog>
</template>
<script lang="ts" setup>
import * as MerchantOrderApi from '@/api/merchant/order'
import { convertToInteger, floatToFixed2, formatToFraction } from '@/utils'
import { cloneDeep } from 'lodash-es'

defineOptions({ name: 'MerchantOrderUpdatePriceForm' })

const message = useMessage()

const dialogVisible = ref(false)
const formLoading = ref(false)
const formData = ref({
  id: undefined as number | undefined,
  adjustPrice: 0,
  payPrice: '',
  newPayPrice: ''
})
watch(
  () => formData.value.adjustPrice,
  (adjustPrice) => {
    const numMatch = formData.value.payPrice.match(/\d+(\.\d+)?/)
    if (numMatch) {
      const payPriceNum = parseFloat(numMatch[0])
      formData.value.newPayPrice = (payPriceNum + adjustPrice).toFixed(2) + '元'
    }
  }
)

const formRef = ref()

const open = async (row: any) => {
  resetForm()
  formData.value.id = row.id!
  formData.value.adjustPrice = Number(formatToFraction(row.adjustPrice || 0))
  formData.value.payPrice = floatToFixed2(row.payPrice!) + '元'
  formData.value.newPayPrice = formData.value.payPrice
  dialogVisible.value = true
}
defineExpose({ open })

const emit = defineEmits(['success'])
const submitForm = async () => {
  formLoading.value = true
  try {
    const { payPrice: _payPrice, newPayPrice: _newPayPrice, ...data } = cloneDeep(unref(formData))
    data.adjustPrice = convertToInteger(data.adjustPrice)
    await MerchantOrderApi.updatePrice(data as { id: number; adjustPrice: number })
    message.success('调价成功')
    dialogVisible.value = false
    emit('success')
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  formData.value = {
    id: undefined,
    adjustPrice: 0,
    payPrice: '',
    newPayPrice: ''
  }
  formRef.value?.resetFields()
}
</script>
